export default {
  placeInput: {
    'findAPlace': 'Buscar por lugares',
    'place': 'Local',
    'addRouteStop': 'Añadir una parada',
    'routePlace': 'Parada',
    'routeDestination': 'Destino',
    'placeNameRequired': 'Nombre del lugar solicitado',
    'yourLocation': 'Su ubicación',
    'couldNotDetermineYourLocation': 'No se puede determinar su ubicación. Asegúrese de conceder los permisos necesarios',
    'useYourLocation': 'Utiliza su ubicación actual',
    'removeInput': 'Eliminar sitio/campo',
    'directions': 'Direcciones',
    'fromYourBrowser': 'desde su dispositivo',
    'addStartingPlace': 'Añadir un punto de partida',
    'startingPlace': 'Punto de partida',
    'openInputOptions': 'Mostrar las opciones del campo',
    'addInput': 'Añadir un campo de ubicación',
    'switchCoords': 'Inverter coordenadas',
    'rawCoordinate': 'Coordenadas simples lat,lng',
    'fillOrRemoveInput': 'Busque o seleccione en el mapa usando el botón de mapa al lado',
    'noPlaceFound': 'Nenhum resultado retornado',
    'unknownSearchPlaceError': 'Error desconocido al buscar el lugar',
    'approximateDistance': 'Distancia aproximada en línea recta desde el centro actual del mapa',
    'couldNotDetermineYourPreciseLocationUsingPreviousLocation': 'No se ha podido determinar su ubicación exacta. Se utilizará su ubicación anterior',
    'pleaseTypeSomething': 'Introduzca algo para buscars',
    'toggleDirect': 'Cambia al modo directo desde aquí a la siguiente ubicación',
    'clickOnTheMapToSelectAPlace': 'Seleccione una ubicación haciendo clic en un punto del mapa',
    'clickOnTheMapBtnToPickAPlace': 'Haga clic en este botón para seleccionar un lugar en el mapa para este campo',
    'goToDirectionsMode': 'Haga clic en el botón de ruta para activar el modo de rutas',
    'clickToSearchAndShowResultsOnTheMap': 'Haga clic para buscar y mostrar los resultados en el mapa'
  }
}
